export default __webpack_public_path__ + "static/media/topTen.f3be199c.png";